import { CandidateRole } from '@internal/components/app/roles';
import { Project } from '@internal/types/projects';

export interface ProjectRole {
  role: CandidateRole | null;
  label: string;
}

const getBoundRole = (
  project: Project,
  roles: CandidateRole[]
): CandidateRole | null => {
  if (!project.contactRoleId) return null;
  const bound = roles.find(
    role => role.contactRoleId === project.contactRoleId
  );
  if (!bound) return null;
  const positionKey = project.hiringPositionRoleKey;
  return !positionKey || bound.role === positionKey ? bound : null;
};

const getPositionRole = (
  project: Project,
  roles: CandidateRole[]
): CandidateRole | null =>
  project.hiringPositionRoleKey
    ? roles.find(role => role.role === project.hiringPositionRoleKey) ?? null
    : null;

export const resolveProjectRole = (
  project: Project,
  roles: CandidateRole[]
): ProjectRole => {
  const role = getBoundRole(project, roles) ?? getPositionRole(project, roles);
  return { role, label: project.hiringPositionRole || role?.label || '' };
};
